export enum ParticipantRole {
  ATTENDEE = "ATTENDEE",
  BADGE_VENDOR = "BADGE_VENDOR",
  BEACON_VENDOR = "BEACON_VENDOR",
  BULK_TICKET_ADMIN = "BULK_TICKET_ADMIN",
  ORGANIZATION_ADMIN = "ORGANIZATION_ADMIN",
  TEAM = "TEAM",
  TEMP = "TEMP",
  TRAVEL_DIRECTOR = "TRAVEL_DIRECTOR",
  SPEAKER = "SPEAKER",
  VENDOR = "VENDOR",
  GENERIC_PARTICIPANT = "GENERIC_PARTICIPANT"
}
